import type { IRaasToolItem } from "../../tools";

export enum MilestoneItemState {
  Active = "active",
  ActiveCompleted = "activeCompleted",
  Completed = "completed",
  Locked = "locked",
  Pending = "pending",
}

export enum MilestonesPaneView {
  Collapsed = "collapsed",
  Expanded = "expanded",
}

export interface IMilestoneItem {
  apiStatus?: string;
  complete?: boolean;
  disabledReason?: string;
  icon: string;
  isStale?: boolean;
  key: string;
  label: string;
  needsReview?: boolean;
  savedAt?: number;
  started?: boolean;
  state: MilestoneItemState;
}

export type IToolItem = IRaasToolItem;
